module.exports = __webpack_public_path__ + "static/media/ComputerTalk_Step1a_Image10.33a25ca9.jpg";